import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./planoManutencaoCadastros.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getPlanosManutencaoById,
  getPlanosManutencaoUpdate,
  getPlanosManutencaoCadastro,
} from "../../services/api_cadastro_planos_manutencao";
import { getTipoManutencao } from "../../services/api_tipos_manutencao";
import { getUsers } from "../../services/api_user";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const PlanosManutencaoRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [descricao, setDescricao] = useState("");
  const [id_user, setUser] = useState("");
  const [id_tipo_manutencao, setTipoManutencao] = useState([]);
  const [user, setUsers] = useState([]);
  const [tipos_manutencao, setTiposManutencao] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Descricao: useRef(null),
    tipoManutencao: useRef(null),
  };

  useEffect(() => {
    const fetchPlanosManutencao = async () => {
      try {
        const response = await getPlanosManutencaoById(id);
        //console.log(response);
        const planos_manutencao = response.data.PlanosManutencao;
        if (planos_manutencao) {
          setDescricao(planos_manutencao.descricao || "");
          setTipoManutencao(planos_manutencao.id_tipo_manutencao || "");
          setUser(planos_manutencao.id_user || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchPlanosManutencao();
    }
  }, [id]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getUsers();
        //console.log(response);

        if (response) {
          const usersAtivos = response.data.Users.filter(
            (user) => user.deleted_at == null
          );
          setUsers(usersAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchUser();
    const interval = setInterval(()=>{
      fetchUser()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchTipoManutencao = async () => {
      try {
        const response = await getTipoManutencao();
        //console.log(response);

        if (response) {
          const tiposManutencaoAtivos = response.data.TiposManutencao.filter(
            (tipoManutencao) => tipoManutencao.deleted_at == null
          );
          setTiposManutencao(tiposManutencaoAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchTipoManutencao();
    const interval = setInterval(()=>{
      fetchTipoManutencao()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!descricao) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento do campo Descrição é obrigatório.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getPlanosManutencaoCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getPlanosManutencaoUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    const id_user = localStorage.getItem("userId");
    if (validarInputs()) {
      setSaving(true)
      let body = {
        descricao,
        id_user,
        id_tipo_manutencao,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 50 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Plano de Manutenção" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formDescricao">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a Descrição"
                    value={descricao}
                    onChange={handleCaracteres}
                    ref={inputRefs.Descricao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.tipoManutencao)}
                  />
                </Form.Group>
              </Col>
             
              <Col md={6} className="mb-3">
                <Form.Group controlId="formTipoManutencao">
                  <Form.Label>Tipo de Manutenção</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_tipo_manutencao}
                    onChange={(e) => setTipoManutencao(e.target.value)}
                  >
                    <option value="">Selecione</option>
                    {tipos_manutencao &&
                      tipos_manutencao.map((id_tipo_manutencao) => (
                        <option
                          key={id_tipo_manutencao.id}
                          value={id_tipo_manutencao.id}
                        >
                          {id_tipo_manutencao.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default PlanosManutencaoRegister;
